export function isTruthy<T>(value: T): value is NonNullable<T> {
  if (value === null || value === undefined) return false;
  if (Array.isArray(value)) return !!value.length;
  if (typeof value === 'object') return !!Object.keys(value).length;
  return !!value;
}

export function isFalsy<T>(value: T) {
  return !isTruthy(value);
}
